import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);

  // On load, validate any saved session token against the server 
  // a stale/expired token should not silently keep someone "logged in".
  useEffect(() => {
    const token = localStorage.getItem('tactmark_token');
    if (!token) {
      setLoading(false);
      return;
    }
    auth
      .me()
      .then(({ user, org }) => {
        setUser(user);
        setOrg(org);
      })
      .catch(() => {
        localStorage.removeItem('tactmark_token');
      })
      .finally(() => setLoading(false));
  }, []);

  const signup = async (orgName, country, email, password, organizationType, teamName, confirmPassword, plan, acceptedTerms) => {
    const { token, user, org } = await auth.signup(orgName, country, email, password, organizationType, teamName, confirmPassword, plan, acceptedTerms);
    localStorage.setItem('tactmark_token', token);
    setUser(user);
    setOrg(org);
    return org;
  };

  const login = async (email, password) => {
    const { token, user, org } = await auth.login(email, password);
    localStorage.setItem('tactmark_token', token);
    setUser(user);
    setOrg(org);
    return org;
  };

  const logout = async () => {
    await auth.logout();
    localStorage.removeItem('tactmark_token');
    setUser(null);
    setOrg(null);
  };

  return (
    <AuthContext.Provider value={{ user, org, loading, signup, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
